export default {
  endpoint: process.env.REACT_APP_BACKEND_URL ?? 'https://jenkins.temera.it/benetton-tmr-api/',
}
